<!-- 资讯 -->
<template>
  <div class="Cooperation_box">
    <div class="Cooperation fd_column">
      <div class="m-b-30">
        <div class="title_mid">
          <img src="@/assets/home/events3226.png" alt="" />
          <div @click="toRouterPush('/Connections')" class="more">
            <div>VIEW MORE</div>
            <img src="@/assets/home/arrow-right-up-line.png" alt="" />
          </div>
        </div>
      </div>
      <div class="component_box">
        <div
          @click="linkJump(1, '/ConnectionsDetail', { id: item.id })"
          class="component_item"
          v-for="item in listData"
          :key="item.id"
        >
          <img :src="$baseImgUrl + item.partnerLogo" alt="" />
        </div>
      </div>
    </div>
    <div class="cooper_bg"><img src="@/assets/home/Con-bg.png" alt="" /></div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { CoogetList } from "@/api/Home/Home";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      listData: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getList() {
      const res = await CoogetList();
      if (res.code === 1) {
        this.listData = res.data;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
</style>
<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./CooperationPC.less";
}
@media screen and (max-width: 750px) {
  @import "./CooperationM.less";
}
</style>
